import angular from 'angular';
import kformUtils from '../../utils/kform-utils';
import template from './kpath.html';

const kpathConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('kpath', {
		title:         'Path',
		template,
		group:         'advanced',
		children:      false,
		selectable:    true,
		settings:      {
			disabled:  false,
			label:     'Path',
			hideLabel: false,
			input:     true,
			tableView: false,
			options:   {
				display: 'breadcrumb',
				mode:    'kpath',
			},
			kdata: {
				kpath_kid: null,
				submit:    true,
			},
			validate:      {
				card: '0-1',
			},
			event: {
				onChange: null,
			},
		},
		icon:          'fa fa-id-card-o',
		views:         [
			{
				name:     'Display',
				template: 'kform/components/kpath/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/kpath/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller: /* @ngInject */ (/** @type {any} */ $scope) => {
			if ($scope.options && $scope.options.building) {
				return;
			}

			$scope.changeValue = () => {
				if ($scope.component.event && typeof $scope.component.event.onChange === 'string') {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};
		},
	});
};

export default angular.module('app').config(kpathConfig);
